import { useEffect } from "react";
import NavBar from "../NavBar";
import { useNavigate } from "react-router-dom";

function Layout(props) {
  const isRoute = window.location.pathname
  const navigation = useNavigate()

 
  return (
    <>
    <div className='bg-bg-lg flex flex-1 w-screen h-screen p-4 flex-col'>
    {props.children}
  
    </div> 
    {isRoute === '/' ? null : <NavBar />}</>
  );
}

export default Layout;
